import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { LanguageService } from './language.service';

function addStroiesInUrl(originalUrl: any, languageId: any, router: Router) {
  originalUrl = originalUrl.replace('/' + languageId, '');
  const modifiedUrl = originalUrl.includes('stories')
    ? `/${languageId}/${originalUrl}`
    : `/${languageId}/stories${originalUrl}`;
  router.navigate([modifiedUrl]);
}

@Injectable({
  providedIn: 'root'
})
export class RouterLanguageGaurdGuard implements CanActivate {
  constructor(private readonly router: Router, private readonly languageService: LanguageService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const languageId = this.languageService.getLanguage();
    let originalUrl = state.url;
    if (
      !originalUrl.startsWith('/login') &&
      !originalUrl.startsWith('/logout') &&
      !originalUrl.includes('/verify') &&
      !originalUrl.includes('/anonymize')
    ) {
      originalUrl = originalUrl.replace(/^\/+/, '');
      const modifiedUrl = `/${languageId}/${originalUrl}`;
      this.router.navigate([modifiedUrl]);
    } else if (originalUrl.includes('verify') || originalUrl.includes('anonymize')) {
      addStroiesInUrl(originalUrl, languageId, this.router);
    }
    return true;
  }
}
